// extracted by mini-css-extract-plugin
export var standaloneTable = "_go-0";
export var standaloneTableWithBodyFill = "_go-1";
export var withExtraHeader = "_go-2";